// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';

export const updateSearchFilters = (property, value) =>

    dispatch => {

        const actionTypes = {
            filterBy: actions.UPDATE_PRODUCTS_BY_CUSTOMER_LIST_FILTER_BY,
            sortBy: actions.UPDATE_PRODUCTS_BY_CUSTOMER_LIST_SORT_BY,
            sortDirection: actions.UPDATE_PRODUCTS_BY_CUSTOMER_LIST_SORT_DIRECTION
        };

        dispatch({
            type: actionTypes[property],
            value
        });

    };



// WEBPACK FOOTER //
// ./src/product/products-by-customer/action-creators/search-filters.js